import gsap from "gsap/all";
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";

export default function ComponentEmphase() {

    const emphases = document.querySelectorAll('.c-emphase')
    if (emphases.length > 0) {
        emphases.forEach(comp => new Emphase(comp))
    } 

}

class Emphase {
    constructor(DOM) {
        this.DOM = DOM;

        // this.animationOnEnterByParagraphe()
        this.animationOnEnterByWords()
    }

    splitText() {
        this.split = Splitting({
            target: this.DOM.querySelector('p'),
            by: 'lines'
        })
    }
    
    animationOnEnterByWords() {
        this.splitText();
      
        gsap.from(this.DOM.querySelectorAll('.c-emphase__wrapper .words .word'), {
            scrollTrigger: this.DOM.querySelector('.c-emphase__wrapper '),
            autoAlpha: 0,
            y: 180,
            duration: 1,
            stagger: 0.1,
            ease: "expo.out"
        })
    }
    

    animationOnEnterByLine() {
        this.splitText();
        console.log(this.split[0].lines)
        
        gsap.from( this.split[0].lines, {
            scrollTrigger: this.DOM.querySelector('.c-emphase__wrapper'),
            onStart : () => {
                console.log("enter")
                this.split[0].lines.forEach( tab => {
                    console.log(tab)
                    gsap.from(tab, {y: 10, stagger : 1})
                    // for(let words in tab){
                    //     console.log(words, tab)
                    // }
                })
            }
        })


    }

    animationOnEnterByParagraphe() {
        
        this.splitText();
        gsap.from(this.DOM.querySelectorAll('.c-emphase__wrapper'), {
            scrollTrigger: this.DOM.querySelector('.c-emphase__wrapper p'),
            autoAlpha: 0,
            y: 180,
            duration: 2,
            stagger: 0.25,
            delay: 0.25,
            ease: "expo.out"
        })
    }

}